/* Sticky add-to-cart bar for product pages.
   Mirrors the real buy box: reads the selected Kaching tier price and clicks the
   actual submit button, so it can never disagree with the form.

   The bar writes its own text, so it must never observe itself - watching the
   whole document would make every render trigger another render. It watches the
   Kaching widget and the theme price only, and pauses while it writes. */
(function () {
  if (!document.body.classList.contains('template-product')) return;

  var form = document.querySelector('[data-product-form]');
  var realBtn = form && form.querySelector('[type="submit"]');
  var titleEl = document.querySelector('.product__title');
  if (!form || !realBtn || !titleEl) return;

  var imgEl = document.querySelector('[data-main-image]');
  var themePrice = document.querySelector('[data-product-price]');
  var themeCompare = document.querySelector('[data-product-compare]');

  var css = document.createElement('style');
  css.textContent = [
    '.satc{position:fixed;left:0;right:0;bottom:0;z-index:60;background:rgba(255,255,255,.97);',
    '-webkit-backdrop-filter:saturate(180%) blur(12px);backdrop-filter:saturate(180%) blur(12px);',
    'border-top:1px solid var(--line);box-shadow:0 -6px 24px rgba(34,24,38,.08);',
    'transform:translateY(110%);transition:transform .26s cubic-bezier(.4,0,.2,1);',
    'padding-bottom:env(safe-area-inset-bottom)}',
    '.satc.is-visible{transform:translateY(0)}',
    '.satc__inner{max-width:var(--page-width);margin:0 auto;display:flex;align-items:center;gap:16px;padding:11px 20px}',
    '.satc__media{width:46px;height:46px;flex-shrink:0;border-radius:10px;overflow:hidden;background:var(--lilac)}',
    '.satc__media img{width:100%;height:100%;object-fit:cover;display:block}',
    '.satc__text{min-width:0;flex:1;display:flex;flex-direction:column;gap:2px}',
    '.satc__title{font-weight:700;font-size:.98rem;line-height:1.2;color:var(--ink);',
    'overflow:hidden;text-overflow:ellipsis;white-space:nowrap}',
    '.satc__prices{display:flex;align-items:baseline;gap:8px;font-size:.95rem;flex-wrap:wrap}',
    '.satc__price{font-weight:700;color:var(--plum);font-size:1.06rem;letter-spacing:-.02em}',
    '.satc__compare{color:var(--ink-soft);text-decoration:line-through;font-size:.86rem}',
    '.satc__save{background:var(--blush);color:var(--plum-deep);font-size:.66rem;font-weight:800;',
    'letter-spacing:.06em;text-transform:uppercase;padding:3px 8px;border-radius:999px}',
    '.satc__btn{flex-shrink:0;min-height:46px;padding:12px 30px;font-size:.95rem}',
    '@media (max-width:640px){',
    '.satc__inner{gap:11px;padding:9px 14px}',
    '.satc__media{display:none}',
    '.satc__title{font-size:.82rem}',
    '.satc__price{font-size:1rem}',
    '.satc__btn{padding:12px 20px;font-size:.9rem}}',
    '@media (max-width:380px){.satc__compare,.satc__save{display:none}}'
  ].join('');
  document.head.appendChild(css);

  var bar = document.createElement('div');
  bar.className = 'satc';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', 'Add to cart');
  bar.innerHTML =
    '<div class="satc__inner">' +
      '<div class="satc__media"></div>' +
      '<div class="satc__text">' +
        '<span class="satc__title"></span>' +
        '<span class="satc__prices">' +
          '<span class="satc__price"></span>' +
          '<s class="satc__compare" hidden></s>' +
          '<span class="satc__save" hidden></span>' +
        '</span>' +
      '</div>' +
      '<button type="button" class="btn btn--primary satc__btn"></button>' +
    '</div>';
  document.body.appendChild(bar);

  var media = bar.querySelector('.satc__media');
  var elTitle = bar.querySelector('.satc__title');
  var elPrice = bar.querySelector('.satc__price');
  var elCompare = bar.querySelector('.satc__compare');
  var elSave = bar.querySelector('.satc__save');
  var btn = bar.querySelector('.satc__btn');

  elTitle.textContent = titleEl.textContent.trim();
  if (imgEl && imgEl.src) {
    var i = new Image();
    i.src = imgEl.src;
    i.alt = '';
    media.appendChild(i);
  } else {
    media.style.display = 'none';
  }

  function money(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function num(s) {
    var v = parseFloat(String(s || '').replace(/[^0-9.,]/g, '').replace(/,/g, ''));
    return isFinite(v) ? v : null;
  }

  function selectedTierPrices() {
    var sel = document.querySelector('.kaching-bundles__bar--selected');
    if (!sel) return null;
    var p = sel.querySelector('.kaching-bundles__bar-price');
    if (!p) return null;
    var c = sel.querySelector('.kaching-bundles__bar-full-price');
    return { price: money(p.textContent), compare: c ? money(c.textContent) : '' };
  }

  // Only touch the DOM when something actually changed.
  function setText(el, value) {
    if (el.textContent !== value) el.textContent = value;
  }
  function setHidden(el, value) {
    if (el.hidden !== value) el.hidden = value;
  }

  var writing = false;

  function sync() {
    if (writing) return;
    writing = true;
    try {
      var src = selectedTierPrices();
      var price = src ? src.price : money(themePrice && themePrice.textContent);
      var compare = src ? src.compare
        : (themeCompare && !themeCompare.hidden ? money(themeCompare.textContent) : '');

      setText(elPrice, price || '');

      if (compare && compare !== price) {
        setText(elCompare, compare);
        setHidden(elCompare, false);
        var a = num(price), b = num(compare);
        if (a && b && b > a) {
          setText(elSave, 'Save ' + Math.round((b - a) / b * 100) + '%');
          setHidden(elSave, false);
        } else {
          setHidden(elSave, true);
        }
      } else {
        setHidden(elCompare, true);
        setHidden(elSave, true);
      }

      setText(btn, (realBtn.textContent || 'Add to cart').replace(/\s+/g, ' ').trim());
      if (btn.disabled !== !!realBtn.disabled) btn.disabled = !!realBtn.disabled;
    } finally {
      // Let the write settle before the observer is allowed to react again.
      setTimeout(function () { writing = false; }, 0);
    }
  }

  sync();

  // The bar is a remote control for the real button - never a second code path.
  btn.addEventListener('click', function () {
    if (!realBtn.disabled) realBtn.click();
  });

  // Watch only the sources, never the bar itself.
  var opts = { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'hidden', 'disabled'] };
  var watched = [];
  var kaching = document.querySelector('.kaching-bundles') || document.querySelector('[data-kaching-slot]');
  if (kaching) watched.push(kaching);
  if (themePrice && themePrice.parentNode) watched.push(themePrice.parentNode);
  if (realBtn.parentNode) watched.push(realBtn.parentNode);

  var mo = new MutationObserver(function () { sync(); });
  watched.forEach(function (n) { mo.observe(n, opts); });

  // Kaching mounts late; re-attach once when its container first appears.
  if (!kaching) {
    var wait = new MutationObserver(function () {
      var k = document.querySelector('.kaching-bundles');
      if (k) { mo.observe(k, opts); sync(); wait.disconnect(); }
    });
    wait.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { wait.disconnect(); }, 15000);
  }

  // Show it only once the real button has scrolled out of view.
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(realBtn);
  } else {
    var onScroll = function () {
      bar.classList.toggle('is-visible', realBtn.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
